<div [pTooltip]="'packages.deleteDisabledRestricted' | translate" [tooltipDisabled]="!disabled()" tooltipPosition="top" appendTo="body">
    <p-button
        [label]="'packages.detail.delete' | translate"
        icon="pi pi-trash"
        severity="danger"
        [outlined]="true"
        [loading]="saving()"
        [disabled]="disabled()"
        [attr.data-test]="testId()"
        (onClick)="onDelete()"
    />
</div>
